import { sumBy } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { withProps } from 'recompose';

import { t } from '../../../../../modules/infra/i18n';
import Money from '../../../../common/money';

const Valuation = ({ supplyValuation, retailValuation }) => (
  <div className="o-flexbox o-flexbox--content-align-center">
    <div className="u-mr+ u-text-center">
      <div className="u-fontsize-small">{t('products:valuation.retail_value')}</div>
      <div className="u-fontsize-small u-type--bold">
        <Money>{retailValuation}</Money>
      </div>
    </div>
    <div className="u-text-center">
      <div className="u-fontsize-small">{t('products:valuation.wholesale_supply_value')}</div>
      <div className="u-fontsize-small u-type--bold">
        <Money>{supplyValuation}</Money>
      </div>
    </div>
  </div>
);

Valuation.propTypes = {
  supplyValuation: PropTypes.number.isRequired,
  retailValuation: PropTypes.number.isRequired,
};

export default withProps((props) => ({
  supplyValuation: sumBy(props.items, (i) => i.supplyPrice * i.inventory),
  retailValuation: sumBy(props.items, (i) => i.price * i.inventory),
}))(Valuation);
